import { addMemberFavouriteLogic } from './addMemberFavouriteLogic';
import { fetchMemberFavouritesLogic } from './fetchMemberFavouritesLogic';
import { removeMemberFavouriteLogic } from './removeMemberFavouriteLogic';

export const logic = [addMemberFavouriteLogic, fetchMemberFavouritesLogic, removeMemberFavouriteLogic];
